module.exports = __webpack_public_path__ + "static/media/lead_icon.48750828.svg";